<template>
  <div class="seat-breakdown">
    <h5>Seat breakdown</h5>
    <section data-testid="core-seat-count">
      <div>
        <h6>{{ coreSeatLimit }} x Full Access seats</h6>
        <p>{{ coreSeatCostFormatted }} per seat/year</p>
      </div>
      <p>{{ totalCoreSeatCostFormatted }}</p>
    </section>
    <section v-if="salesSeatLimit" data-testid="sales-seat-count">
      <div>
        <h6>{{ salesSeatLimit }} x Sales seats</h6>
        <p>{{ salesSeatCostFormatted }} per seat/year</p>
      </div>
      <p>{{ totalSalesSeatCostFormatted }}</p>
    </section>
    <section data-testid="total-cost">
      <h5>Total</h5>
      <p class="font-bold text-success-text">{{ totalCost }}</p>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import useSeats from '@/composables/useSeats';
import { FULL_ACCESS, SALES_ONLY, SEAT_COSTS } from '@/constants/billing';
import { centsToDollars } from '@/utils';

const { salesSeatLimit, coreSeatLimit } = useSeats();

const coreSeatCostCents = SEAT_COSTS[FULL_ACCESS].year;
const salesSeatCostCents = SEAT_COSTS[SALES_ONLY].year;

const totalCost = computed(() => {
  const coreCost = coreSeatLimit.value * coreSeatCostCents;
  const salesCost = salesSeatLimit.value * salesSeatCostCents;
  return centsToDollars(coreCost + salesCost);
});

const coreSeatCostFormatted = computed(() => {
  return centsToDollars(coreSeatCostCents);
});
const totalCoreSeatCostFormatted = computed(() => {
  const totalCoreCost = coreSeatLimit.value * coreSeatCostCents;
  return centsToDollars(totalCoreCost);
});

const salesSeatCostFormatted = computed(() => {
  return centsToDollars(salesSeatCostCents);
});
const totalSalesSeatCostFormatted = computed(() => {
  const totalSalesCost = salesSeatLimit.value * salesSeatCostCents;
  return centsToDollars(totalSalesCost);
});
</script>

<style scoped lang="pcss">
.seat-breakdown {
  @apply flex flex-col;
}
h5 {
  @apply font-bold text-base text-neutral-text-strong;
}
div > p {
  @apply text-sm;
}
section {
  @apply border-b border-solid border-neutral-border py-16 flex items-center justify-between;
  &:last-child {
    @apply border-b-0;
  }
}
</style>
